module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<i class="far fa-chart-bar section-icon"></i>\n<div class="report-name" data-action="action:open">' +
((__t = ( data.name )) == null ? '' : __t) +
'</div>\n';
 if (data.controls) { ;
__p += '\n<div class="actions">\n    <a href="#" data-action="action:open" class="open tooltipped tooltipped-n" aria-label="' +
((__t = ( strings.reports_open_report_tooltip )) == null ? '' : __t) +
'"><i class="far fa-external-link-alt"></i></a>\n    <a href="#" data-action="action:delete" class="tooltipped tooltipped-n" aria-label="' +
((__t = ( strings.reports_delete_report_tooltip)) == null ? '' : __t) +
'"><i class="far fa-trash-alt"></i></a>\n</div>\n';
 } ;

return __p
}